// Access tiers — built row-for-row from the owner's Access Matrix sheet (memory/access_matrix_filled_2026-10-27.xlsx).
// Tiers: admin (Super Admin + org admins) · trainer · player · family · agent (Agent/Coach; legacy "viewer" members map here) · lite (minimal dashboard).
// To change who sees what: edit ACCESS below (keys = tab.section). A tab is visible when at least one of its sections is.

export const TIERS = ["admin", "trainer", "player", "family", "agent", "lite"];
export const TIER_LABEL = { admin: "Admin", trainer: "Trainer", player: "Player", family: "Family", agent: "Agent / Coach", lite: "Lite" };
const FULL = ["admin", "trainer", "player", "family", "agent"];   // every tier except Lite
const ALL = [...FULL, "lite"];
const ADMIN = ["admin"];

export const ACCESS = {
  // Header
  "header.hero": ALL,
  "header.share_access": ADMIN,
  "header.view_as": ADMIN,
  // Development Inventory
  "inventory.bio": ["admin", "lite"],
  "inventory.assess": ADMIN,
  "inventory.toolbar": ADMIN,
  "inventory.review": ALL,
  "inventory.archetype": ALL,
  "inventory.current_role": ALL,
  "inventory.vibes": ["admin", "trainer", "agent"],
  "inventory.badges": ADMIN,
  "inventory.feedback_report": ADMIN,
  // Analytics
  "analytics.averages": FULL,
  "analytics.game_log": FULL,
  "analytics.shot_chart": FULL,
  "analytics.advanced_shooting": FULL,
  "analytics.extended": FULL,
  "analytics.hs_kpis": ADMIN,
  "analytics.hs_dominate": ADMIN,
  // Season Stats
  "season_stats.headline": ADMIN,
  "season_stats.advanced": ADMIN,
  "season_stats.shot_types": ADMIN,
  "season_stats.play_types_offense": ADMIN,
  "season_stats.play_types_defense": ADMIN,
  "season_stats.edit": ADMIN,
  // Shot Diet
  "shot_diet.evaluation": ADMIN,
  "shot_diet.profile": ADMIN,
  "shot_diet.transition_half_court": ADMIN,
  "shot_diet.play_types": ADMIN,
  "shot_diet.recommendations": ADMIN,
  // Film Reviews
  "film.list": ALL,
  "film.edit": ADMIN,
  // IQ
  "iq.courses": ALL,
  "iq.mini_courses": ALL,
  "iq.suggested_film": ADMIN,
  "iq.assign": ADMIN,
  // Training
  "training.priorities": FULL,
  "training.plan": ADMIN,
  "training.routines": ALL,
  "training.routines_edit": ADMIN,                  // per the 2026-10-28 sheet; add "trainer" here to let trainers build routines again
  "training.routine_templates_edit": ADMIN,         // the shared template library stays admin-only
  "training.workout_log": FULL,
  "training.shooting_assessment": ADMIN,
  // Recruitment (HS)
  "recruitment.academic": FULL,
  "recruitment.schools": FULL,
  "recruitment.kenpom": FULL,
  // Projections
  "projections.main": ADMIN,
  // Player Home tiles follow their tab's visibility (see tabVisible)
  // Org pages
  "org.my_players": ALL,          // landing list for per-player logins (kept for every tier so multi-player logins can pick a player)
  "org.dashboard": ADMIN,
  "org.trending": ADMIN,
  "org.compare": ADMIN,
  "org.library": ADMIN,
  "org.coach_dashboard": ADMIN,
  "org.admin": ADMIN,
};

export function tierOf(user) {
  if (!user) return null;
  if (user.is_super_admin) return "admin";
  const r = user.active_org_role || user.role || "viewer";
  if (r === "admin") return "admin";
  if (r === "viewer") return "agent";
  return TIERS.includes(r) ? r : "agent";
}

export const can = (user, key) => { const t = tierOf(user); return !!t && (ACCESS[key] || []).includes(t); };

export const tabVisible = (user, tab) => Object.keys(ACCESS).some(k => k.startsWith(tab + ".") && can(user, k));

/** Tabs (in display order) this user may see for a player of the given league. */
export function visibleTabs(user, league) {
  const order = ["inventory", "analytics", "season_stats", "shot_diet", "film", "iq", "training", ...(league === "HS" ? ["recruitment"] : []), "projections"];
  return order.filter(t => tabVisible(user, t));
}
